import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { Area } from "src/app/shared/model/tickets/area.model";
import { TicketsService } from "../../tickets.service";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { Persona } from "src/app/shared/model/security/persona.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { Prioridad } from "src/app/shared/model/tickets/prioridad.model";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { MatSelectionList, MatListOption } from "@angular/material/list";
import { ReplaySubject } from "rxjs";
import { TicketCapacitacion } from "src/app/shared/model/tickets/ticketCapacitacion.model";
import { DatePipe, Location, NgFor, NgIf, AsyncPipe } from "@angular/common";
import { Tickets } from "src/app/shared/model/tickets/tickets.model";
import { TicketPrioridad } from "src/app/utilerias/enums/ticket-prioridad.enum";
import swal from "sweetalert2";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { Router } from "@angular/router";
import { MatFormField, MatLabel, MatError, MatInput, MatSuffix } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/autocomplete";
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from "@angular/material/datepicker";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { regresaDeSolicitud } from "../regreso-solicitud";
@Component({
    selector: "app-solicitud-capacitacion-tickets",
    standalone: true,
    templateUrl: "./solicitud-capacitacion-tickets.component.html",
    styleUrls: ["./solicitud-capacitacion-tickets.component.css"],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, NgFor, MatOption, NgIf, MatError, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgxMatSelectSearchModule, MatSelectionList, MatListOption, AsyncPipe, DatePipe]
})
export class SolicitudCapacitacionTicketsComponent implements OnInit {
  options: FormGroup;
  areas: Area[] = [];
  areaSeleccionada: Area = new Area();
  usuario: Persona;
  nombreSolicitante: string = "";
  fechaSolicitud: Date = new Date();
  areaSolicitante: String = "";
  justificacion: string = "";
  nombreProyecto: string = "";
  nombreCurso: string = "";
  prioridades: Prioridad[];
  niveles: string[];
  objetivos: string[];
  prioridad: Prioridad = new Prioridad();
  temaCurso: string = "";
  objetivo: string = "";
  fechaCapacitacion: Date;
  observaciones: string = "";
  nivel: string;
  listaPersonal: Empleado[] = [];
  listaEmpleados: Array<Empleado>;
  nombreEmpleado: string = "";
  listaFiltrada: Empleado[] = [];
  formArea = new FormControl();
  public filterArea: ReplaySubject<Area[]> = new ReplaySubject<Area[]>(1);
  ticketSolicitudCapacitacion: TicketCapacitacion = new TicketCapacitacion();

  @ViewChild("listaDisponible") listaDisponible: MatSelectionList;
  @ViewChild("listaSeleccionada") listaSeleccionada: MatSelectionList;
  constructor(
    private ticketsService: TicketsService,
    private fb: FormBuilder,
    private empleadoService: EmpleadoService,
    public datepipe: DatePipe,
    private msg: Msg,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit(): void {


    this.niveles=["Básico","Intermedio","Avanzado"];

    this.objetivos=[
      "Integración a la organización (Inducción)",
      "Actualizar y perfeccionar conocimientos y habilidades",
      "Proporcionar información de nuevas tecnologías",
      "Preparar para ocupar vacantes o puestos de nueva creación",
      "Prevenir riesgos de trabajo",
      "Incremento a la Productividad",
      "Actualizar y/o perfeccionar conocimientos y habilidades",
      "Proporcionar información de nuevas tecnologías",
      "Preparar para ocupar vacantes o puestos de nueva creación"     ,
      "Prevenir riesgos de trabajo",
      "Incremento a la Productividad"
    
    ];
    this.formArea.valueChanges.subscribe(() => {
      this.filtraAreas();
    });
    var usuarioJson = JSON.parse(localStorage.CosData);
    this.usuario = usuarioJson.persona;
    this.nombreSolicitante = this.usuario.nombreCompleto;

    this.options = this.fb.group({
    prioridadCtrl: ["", Validators.required],
      nombreCursoCtrl: ["", Validators.required],
      temaCursoCtrl: ["", Validators.required],
      nivelCtrl: ["", Validators.required],
      fechaCapacitacionCrtl: ["", Validators.required],
      objetivoCtrl: ["", Validators.required],
      justificacionCtrl: ["", Validators.required],
      observacionesCtrl: ["", Validators.required],
     // nombreProyectoCtrl: ["", Validators.required],
    });
    this.buscarAreas();
    this.buscarPrioridades();
    this.buscarPersonal();
  }

  filtraAreas() {
    if (!this.areas) {
      return;
    }
    let search = this.formArea.value;
    if (!search) {
      this.filterArea.next(this.areas.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterArea.next(
      this.areas.filter((area) => area.area.toLowerCase().indexOf(search) > -1)
    );
  }

  buscarAreas() {
    this.ticketsService
      .consultarArea(UrlConstantes.consultarArea)
      .subscribe((res) => {
        if (res != null) {
          let area = new Area();
          area.area = "Todas";
          this.areas = res.list;
          this.areas.unshift(area);
          this.buscarAreaSolicitante();
          this.filtraAreas();
        }
      });
  }

  buscarAreaSolicitante() {
    this.ticketsService
      .consultarArea(UrlConstantes.consultarAreaUser)
      .subscribe((res) => {
        if (
          null != res &&
          null != res.list &&
          res.list.length >= Constantes.UNO
        ) {
          this.areas.forEach((element) => {
            if (res.list[Constantes.CERO].id === element.id) {
              this.areaSolicitante = element.area;
              this.nombreSolicitante = this.usuario.nombreCompleto;
            }
          });
        }
      });
  }

  buscarPrioridades() {
    this.ticketsService.consultarPrioridad().subscribe((resp) => {
      if (resp != null) {
        this.prioridades = resp.list;
      }
    });
  }

  buscarPersonal() {
    this.empleadoService.consultaEmpleadosActivos().subscribe((res) => {
      this.listaEmpleados = res.list;
      this.listaFiltrada = this.listaEmpleados;
    });
  }

  // Función para filtrar empleados en base al nombre ingresado
  filtrarEmpleadosPorNombre(event: any) {
    this.nombreEmpleado = event.target.value;
    if (
      this.nombreEmpleado.trim() === "" &&
      (this.areaSeleccionada.id === null ||
        this.areaSeleccionada.id === undefined)
    ) {
      // Si el filtro está vacío, muestra todos los empleados
      this.listaFiltrada = this.listaEmpleados;
    } else if (this.areaSeleccionada.id) {
      // Filtra empleados por Area
      this.listaFiltrada = this.listaEmpleados.filter(
        (empleado) => empleado.puesto.id_area == this.areaSeleccionada.id
      );
      // Filtra empleados por nombre
      this.listaFiltrada = this.listaFiltrada.filter((empleado) =>
        empleado.persona.nombreCompleto
          .toLowerCase()
          .includes(this.nombreEmpleado.toLowerCase())
      );
    } else {
      // Filtra empleados por nombre
      this.listaFiltrada = this.listaFiltrada.filter((empleado) =>
        empleado.persona.nombreCompleto
          .toLowerCase()
          .includes(this.nombreEmpleado.toLowerCase())
      );
    }
  }

  // Función para filtrar empleados en base al area
  filtrarEmpleadosPorArea(event: any) {
    this.areaSeleccionada = event.value;
    if (
      (this.areaSeleccionada.id === null ||
        this.areaSeleccionada.id === undefined) &&
      this.nombreEmpleado.trim() === ""
    ) {
      // Si el filtro está vacío, muestra todos los empleados
      this.listaFiltrada = this.listaEmpleados;
    } else if (
      !(
        this.areaSeleccionada.id === null ||
        this.areaSeleccionada.id === undefined
      ) &&
      this.nombreEmpleado.trim() !== ""
    ) {
      // Filtra empleados por Area
      this.listaFiltrada = this.listaEmpleados.filter(
        (empleado) => empleado.puesto.id_area == this.areaSeleccionada.id
      );
      // Filtra empleados por nombre
      this.listaFiltrada = this.listaFiltrada.filter((empleado) =>
        empleado.persona.nombreCompleto
          .toLowerCase()
          .includes(this.nombreEmpleado.toLowerCase())
      );
    } else if (
      (this.areaSeleccionada.id === null ||
        this.areaSeleccionada.id === undefined) &&
      this.nombreEmpleado.trim() !== ""
    ) {
      // Si el filtro está vacío, muestra todos los empleados
      this.listaFiltrada = this.listaEmpleados;
      // Filtra empleados por nombre
      this.listaFiltrada = this.listaFiltrada.filter((empleado) =>
        empleado.persona.nombreCompleto
          .toLowerCase()
          .includes(this.nombreEmpleado.toLowerCase())
      );
    } else {
      // Filtra empleados por Area
      this.listaFiltrada = this.listaEmpleados.filter(
        (empleado) => empleado.puesto.id_area == this.areaSeleccionada.id
      );
    }
  }

  limpiar(): void {
    this.options.reset();
    this.listaPersonal = [];
    //Establecer los valores por defecto
    this.valoresPorDefecto();
  }

  valoresPorDefecto() {
    this.buscarAreaSolicitante();
    this.fechaSolicitud = new Date();
  }

  agregarOpcionesSeleccionadas() {
    const opcionesSeleccionadas =
      this.listaDisponible.selectedOptions.selected.map(
        (opcion) => opcion.value
      );
    // Verificar duplicados antes de agregar a listaPersonal
    opcionesSeleccionadas.forEach((persona) => {
      if (!this.listaPersonal.includes(persona)) {
        this.listaPersonal.push(persona);
      }
    });
  }

  eliminarOpcionesSeleccionadas() {
    // Obtén las opciones seleccionadas de listaDisponible
    const opcionesSeleccionadas =
      this.listaSeleccionada.selectedOptions.selected.map(
        (opcion) => opcion.value
      );
    // Filtra la listaPersonal para mantener solo las no seleccionadas
    this.listaPersonal = this.listaPersonal.filter(
      (opcion) => !opcionesSeleccionadas.includes(opcion)
    );
  }

  guardar() {
    if (this.listaPersonal.length === 0) {
      this.msg.warningCall(
        "Favor de agregar el personal a capacitar.",
        "Información",
        (result) => {}
      );
      return;
    } else {
      let ticketBase = new Tickets();
      switch (this.prioridad.nombre) {
        case "Alta":
          ticketBase.prioridad = TicketPrioridad.ALTA;
          break;
        case "Media":
          ticketBase.prioridad = TicketPrioridad.MEDIA;
          break;
        case "Baja":
          ticketBase.prioridad = TicketPrioridad.BAJA;
          break;
        default:
          break;
      }

      ticketBase.justificacion = this.justificacion;
      ticketBase.asunto = "SOLICITUD DE CAPACITACIÓN";
      this.ticketSolicitudCapacitacion.ticket = ticketBase;
      this.ticketSolicitudCapacitacion.fechaReqCap = this.datepipe.transform(
        this.fechaCapacitacion,"yyyy-MM-dd");
      // this.ticketSolicitudCapacitacion.nombreProyecto = this.nombreProyecto;
      this.ticketSolicitudCapacitacion.nombreCurso = this.nombreCurso;
      this.ticketSolicitudCapacitacion.nivelCurso = this.nivel;
      this.ticketSolicitudCapacitacion.objetivoCurso = this.objetivo;
      this.ticketSolicitudCapacitacion.observaciones = this.observaciones;
      this.ticketSolicitudCapacitacion.temaRequerido = this.temaCurso;
      this.ticketSolicitudCapacitacion.personalCap = this.listaPersonal;
      this.ticketsService.guardarCapacitacionTicket(this.ticketSolicitudCapacitacion).subscribe((res) => {
          if (res != null && res.pCodRetorno === Constantes.EXITO) {
            this.ticketSolicitudCapacitacion = res;
            swal
              .fire({
                title:
                  "¡Se ha generado la solicitud de Ticket! Con el folio: " +
                  this.ticketSolicitudCapacitacion.ticket.id_ticket,
                timer: 5000,
                icon: "success",
                showConfirmButton: true,
              })
              .then((responeMsg) => {
             //   this.modal.close(this.ticketSolicitudCapacitacion);
             this.router.navigate(["TICKETS/Cte"]);
              });
          } else {
            swal.fire({
              title: " Fallo la generación del Ticket.",
              timer: 5000,
              icon: "error",
              showConfirmButton: true,
            });
          }
        });
    }
  }

  onCloseClick() {
    regresaDeSolicitud(this.location, this.router);
  }

  seleccionarTodosDisponibles() {
    this.listaDisponible.selectedOptions.select(
      ...this.listaDisponible.options.toArray()
    );
  }

  deseleccionarTodosDisponibles() {
    this.listaDisponible.selectedOptions.deselect(
      ...this.listaDisponible.options.toArray()
    );
  }

  seleccionarTodosCapacitar() {
    this.listaSeleccionada.selectedOptions.select(
      ...this.listaSeleccionada.options.toArray()
    );
  }

  deseleccionarTodosCapacitar() {
    this.listaSeleccionada.selectedOptions.deselect(
      ...this.listaSeleccionada.options.toArray()
    );
  }
}
